import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.departmentOverview.title',
    defaultMessage: 'Department Overview',
  },
  activeEmployees: {
    id: 'pages.departmentOverview.viewModes.activeEmployees',
    defaultMessage: 'Active Employees',
  },
  inactiveEmployees: {
    id: 'pages.departmentOverview.viewModes.inactiveEmployees',
    defaultMessage: 'Inactive Employees',
  },
  deletedScorecards: {
    id: 'pages.departmentOverview.viewModes.deletedScorecards',
    defaultMessage: 'Deleted Scorecards',
  },
  profiles: {
    id: 'pages.departmentOverview.viewModes.profiles',
    defaultMessage: 'Profiles',
  },
  exportData: {
    id: 'pages.departmentOverview.exportData',
    defaultMessage: 'Export Data',
  },
  filterByName: {
    id: 'pages.departmentOverview.filterByName',
    defaultMessage: 'Filter by name',
  },
  typeName: {
    id: 'pages.departmentOverview.typeName',
    defaultMessage: 'Type name',
  },
});
